<template>
  <div>
    <el-form label-width="120px">
      <el-form-item label="用户手机号">
        <el-input v-model.number="obj.phone_number"></el-input>
      </el-form-item>
      <el-form-item label="确认手机号">
        <el-input v-model.number="obj.phone_number_makesure"></el-input>
      </el-form-item>
    </el-form>
    <el-button type="primary" @click="submit">升级算料版</el-button>
  </div>
</template>

<script>
export default {
  data:()=>({
    obj:{
      phone_number:'',
      phone_number_makesure:'',
      
    },
  }),
  methods:{
    submit(){
      if(!/^1\d{10}$/.test(this.obj.phone_number)){
        this.$message.error("请输入正确的手机号！");
        return
      }
      if(!/^1\d{10}$/.test(this.obj.phone_number_makesure)){
        this.$message.error("请输入正确的手机号！");
        return
      }
      if(this.obj.phone_number!=this.obj.phone_number_makesure){
        this.$message.error("两次手机号不匹配！");
        return
      }
      var param = JSON.parse(JSON.stringify(this.obj))
      delete param.phone_number_makesure
      this.$axios.post('admin-add-model',param).then(res=>{
        if(res.code==1){
          this.$message({
            message:res.message,
            type:"success"
          })
        }else{
          this.$message.error(res.message)
        }
      })
    }
  }

}
</script>

<style>

</style>